export var FileAttributeType;
(function (FileAttributeType) {
    FileAttributeType["String"] = "string";
    FileAttributeType["Number"] = "number";
    FileAttributeType["Date"] = "date";
    FileAttributeType["Rights"] = "rights";
})(FileAttributeType || (FileAttributeType = {}));
export class FileSystem {
}
